/*
If a new language is added here you will also have to add that language to app.module.ts and translation-service.ts
*/

export enum Language {
  ENGLISH = 'en',
  ENGLISH_GB = 'en-GB',
  ENGLISH_PA = 'en-PA',
  ENGLISH_US = 'en-US',
  SWEDISH = 'sv',
  SWEDISH_SE = 'sv-SE',
  SWEDISH_PA = 'sv-PA',
  GERMAN = 'de',
  GERMAN_DE = 'de-DE',
  GERMAN_CH = 'de-CH',
  SPANISH = 'es',
  SPANISH_ES = 'es-ES',
  FRENCH = 'fr',
  FRENCH_FR = 'fr-FR',
  DUTCH = 'nl',
  DUTCH_NL = 'nl-NL',
}

export const simpleLanguageCodes = [
  Language.SWEDISH,
  Language.ENGLISH,
  Language.GERMAN,
  Language.FRENCH,
  Language.SPANISH,
  Language.DUTCH,
];
